import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'rsGetArrayFromNumberToIterate' })
export class GetArrayFromNumberToIteratePipe implements PipeTransform {
  transform(digit: number): string[] {
    return Array(digit).fill('');
  }
}
